export default __webpack_public_path__ + "img/4-1-206639c9.png";